import { useMemo } from 'react'
import {
  CreatorStage,
  creatorGroups,
  creatorStages,
  StageId,
  stageIndexOf,
} from '../../modules/creator/steps/creatorSteps'
import { Step } from '../../modules/creator/Stepper'

const stageStatus = (
  stage: CreatorStage,
  currentIndex: number,
): Step['status'] => {
  const idx = stageIndexOf(stage.id)
  if (idx < currentIndex) return 'completed'
  if (idx === currentIndex) return 'active'
  return 'upcoming'
}

export const useStepsWithStatus = (currentStageId: StageId) => {
  return useMemo(() => {
    const currentIndex = stageIndexOf(currentStageId)

    return creatorGroups.map<Step>((group) => {
      const stages = creatorStages.filter((s) => s.groupId === group.id)
      const stageStatuses = stages.map((s) => stageStatus(s, currentIndex))

      let groupStatus: Step['status'] = 'upcoming'
      if (stageStatuses.every((s) => s === 'completed')) {
        groupStatus = 'completed'
      } else if (stageStatuses.some((s) => s === 'active' || s === 'completed')) {
        groupStatus = 'active'
      }

      const children =
        stages.length > 1
          ? stages.map<Step>((s, idx) => ({
              id: s.id,
              title: s.title,
              status: stageStatuses[idx],
            }))
          : undefined

      return {
        id: group.id,
        title: group.title,
        status: groupStatus,
        children,
      }
    })
  }, [currentStageId])
}
